import { render, staticRenderFns } from "./EligibilityRejectionDialog.vue?vue&type=template&id=f76cdcda&scoped=true"
import script from "./EligibilityRejectionDialog.vue?vue&type=script&lang=js"
export * from "./EligibilityRejectionDialog.vue?vue&type=script&lang=js"
import style0 from "./EligibilityRejectionDialog.vue?vue&type=style&index=0&id=f76cdcda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f76cdcda",
  null
  
)

export default component.exports